import React from 'react';
import { InternalStandardProps, Typography } from '@mui/material';
import { parsePathToString } from '../../../crud-core/utils/Path';

export type TextFieldProps = {
  field: string;
  item?: Object;
  label?: string;
  modifier?: (input: string) => string;
} & InternalStandardProps<React.HTMLAttributes<HTMLDivElement>>;

const TextField: React.FC<TextFieldProps> = ({
  className,
  field,
  item = {},
  style,
  modifier = (input: string) => input,
}: TextFieldProps) => {
  const value = modifier(parsePathToString(field, item));
  return (
    <Typography component="span" variant="body2" className={className} style={style}>
      {value}
    </Typography>
  );
};

// eslint-disable-next-line import/no-default-export
export default TextField;
